import React, { useState } from "react";
import { Order } from "../../interfaces/order";
import { deleteOrder } from "../../services/orderService";
import HardDeleteOrder from "./HardDeleteOrder";
import { useNavigate } from "react-router-dom";

interface DeleteOrderProps {
  order: Order;
  onClose: (message?: string) => void;
  onSuccess: () => void;
}

const DeleteOrder: React.FC<DeleteOrderProps> = ({
  order,
  onClose,
  onSuccess,
}) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [deleteText, setDeleteText] = useState("");
  const [showHardDeleteOrder, setShowHardDeleteOrder] = useState(false);
  const navigate = useNavigate();

  const handleDeleteOrder = async () => {
    try {
      setLoadingSpinner(true);

      await deleteOrder(order.orderID, deleteText);

      onSuccess();
    } catch (error) {
      setErrorMessage("Failed to delete the order. Please try again.");
      setLoadingSpinner(false);
    }
  };

  if (showHardDeleteOrder) {
    return (
      <HardDeleteOrder
        order={order}
        onClose={() => {
          setShowHardDeleteOrder(false);
        }}
        onSuccess={() => {
          onClose();
          navigate("/admin/orders/all", {
            state: {
              successMessage: "Order delete successfully",
              reload: true,
            },
          });
        }}
      />
    );
  }

  return (
    <>
      <div className="background-mask" onClick={() => onClose()}></div>
      <div className="filter-popup">
        <div className="close-button-container">
          <button className="close-button" onClick={() => onClose()}>
            <i className="bi bi-x-circle"></i>
          </button>
        </div>
        <div className="filter-header">
          <h2>Delete Order</h2>
          <div>
            <b>Are you sure you would like to delete this order?</b>{" "}
          </div>
          <div>
            After delete you cannot make changes to this order or reactivate
            it.{" "}
          </div>
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <label style={{ display: "block", marginBottom: "0.5rem" }}>
            Delete Message:
          </label>
          <textarea
            value={deleteText}
            onChange={(e) => setDeleteText(e.target.value)}
            rows={4}
            style={{ width: "100%" }}
            maxLength={500}
          />
          <div
            style={{
              fontSize: "14px",
              marginTop: "4px",
              textAlign: "right",
            }}
          >
            {deleteText?.length ?? 0}/500
          </div>
        </div>
        <div className="filter-actions">
          <button className="smbtn btn-grey" onClick={() => onClose()}>
            Cancel
          </button>
          <button className={`smbtn btn-red`} onClick={handleDeleteOrder}>
            Delete
          </button>
          <button
            className={`smbtn btn-red`}
            onClick={() => setShowHardDeleteOrder(true)}
          >
            Hard Delete
          </button>
        </div>
        {errorMessage && <div className="error-message">{errorMessage}</div>}
      </div>
      {loadingSpinner && (
        <div className="loading-mask">
          <div className="loading-spinner"></div>
        </div>
      )}
    </>
  );
};

export default DeleteOrder;
